// extracted by mini-css-extract-plugin
export default {"Ticket":"Ticket_Ticket__DYb0o","TicketContent":"Ticket_TicketContent__H9Vek"};